module.exports = __webpack_public_path__ + "img/black-3.1ec22d95.png";